import React, { useState } from 'react';
import {
  StyledBannerContainer,
  StyledCloseIcon,
  ContentWrapper,
  StyledText,
  ActionsWrapper,
  StyledLink,
  StyledLinkDecline,
  StyledCloseButton,
} from './CookiesBanner.styles';
import ReactHtmlParser from 'react-html-parser';
import { cookiesSectionData } from '@data-ts/shared/sections/cookies.data';
const { segment } = require('../../static/js/joy');
import { getLocalStorage } from '@utils/storage';

export const COOKIE_STATUS = 'cookiesStatus';
export const COOKIE_STATUS_ACCEPTED = 'accepted';
export const COOKIE_STATUS_DECLINED = 'declined';
export const COOKIE_BANNER_CLOSED = 'cookiesBannerCosed';

export interface CookiesBannerProps<T> {
  onAction: () => void;
  onClose: () => void;
}

export const CookiesBanner = <T extends string>({ onAction, onClose }: CookiesBannerProps<T>) => {
  const [isDeclined, setIsDiclined] = useState(getLocalStorage().getItem(COOKIE_STATUS) === COOKIE_STATUS_DECLINED);
  const [showBanner, setShowBanner] = useState(false);
  setTimeout(() => {
    setShowBanner(true);
  }, 1000);
  const declineCookies = () => {
    getLocalStorage().setItem(COOKIE_STATUS, COOKIE_STATUS_DECLINED);
    segment.deleteAllCookies();
    setIsDiclined(true);
    onAction();
  };
  const acceptAllCookies = () => {
    getLocalStorage().setItem(COOKIE_STATUS, COOKIE_STATUS_ACCEPTED);
    onAction();
    location.reload();
  };
  if (getLocalStorage().getItem(COOKIE_STATUS) !== COOKIE_STATUS_ACCEPTED) {
    segment.deleteAllCookies();
  }
  const { bodyText, bodyTextDeclined, acceptAll, decline } = cookiesSectionData;
  return (
    <StyledBannerContainer alignItems="center" justifyContent="center" showBanner={showBanner}>
      <StyledCloseButton id="cookieConsentIgnore" onClick={() => onClose()}>
        <StyledCloseIcon name="notAttending" color={'neutra6'} />
      </StyledCloseButton>
      <ContentWrapper>
        <StyledText color="neutra5" variant="dek15" tagName="p" textAlign={'left'}>
          {ReactHtmlParser(isDeclined ? bodyTextDeclined : bodyText)}
        </StyledText>
      </ContentWrapper>
      <ActionsWrapper>
        <StyledLink id="cookieConsentAccept" variant="altPurpleSecondary" onClick={acceptAllCookies}>
          {acceptAll}
        </StyledLink>
        {!isDeclined ? (
          <StyledLinkDecline id="cookieConsentDecline" variant="altPurpleSecondary" onClick={declineCookies}>
            {decline}
          </StyledLinkDecline>
        ) : null}
      </ActionsWrapper>
    </StyledBannerContainer>
  );
};
